<template>
  <div id="app" class="full-height">
    <top-bar v-if="activePageCode !== 'landing'"></top-bar>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import topBar from './components/shared/nav/top-bar.vue'

export default {
  name: 'app',
  components: {
    'top-bar': topBar
  },
  computed: {
    ...mapGetters({
      activePageCode: 'getActivePageCode'
    })
  }
}
</script>

<style lang="scss">
  @import './styles/main.scss'
</style>
